var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fields)?_c('div',{staticClass:"field-list"},[_vm._l((_vm.fields),function(field,fieldName){return [_c('field-item',{attrs:{"field":field,"data":_vm.data,"fieldName":fieldName}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }